import { Component, inject, Input, input, output } from '@angular/core';

import { OVERLAY_DATA, OverlayRef } from '@app-core/services/overlay';
import { ButtonComponent } from '@app-shared/components/button/button.component';
import { IconComponent } from '@app-shared/components/icon/icon.component';
import { SimpleDialogAction, SimpleDialogItem } from '@app-shared/components/simple-dialog/simple-dialog.interface';

@Component({
  templateUrl: './simple-dialog.component.html',
  styleUrls: ['./simple-dialog.component.scss'],
  imports: [IconComponent, ButtonComponent],
})
export class SimpleDialogComponent implements SimpleDialogItem {
  dialog = inject<SimpleDialogItem>(OVERLAY_DATA);
  private ref = inject<OverlayRef<SimpleDialogComponent>>(OverlayRef);

  @Input({ required: true }) actions: SimpleDialogAction[];
  @Input({ required: true }) value: { message: string; title: string };
  @Input({ required: true }) id: string = '';
  @Input({ required: true }) standalone: boolean = true;

  readonly closed = output<string>();

  act(action: (notifications: OverlayRef<SimpleDialogComponent> | SimpleDialogComponent) => void): void {
    action(this.standalone ? this.ref : this);
  }

  update(value: SimpleDialogItem): void {
    Object.assign(this.dialog.value, value);
  }

  close(): void {
    this.standalone ? this.ref.close() : this.closed.emit(this.id);
  }
}
